//Bar Animation

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".custom-header__bar-message");
  let currentIndex = 0;

  function switchItem() {
    const currentItem = items[currentIndex];
    currentItem.classList.remove("active");

    currentIndex = (currentIndex + 1) % items.length;
    const nextItem = items[currentIndex];

    setTimeout(() => {
      currentItem.style.display = "none"; 
      nextItem.style.display = "flex";

      setTimeout(() => {
        nextItem.classList.add("active");
      }, 50); 
    }, 500); 
  }

  if (items.length > 0) {
    items[currentIndex].style.display = "flex";
    items[currentIndex].classList.add("active");
  }

  setInterval(switchItem, 2500);
});

//Mobile search input show/hide

const showButton = document.querySelector('.custom-header__search-button-mobile');
const inputBar = document.querySelector('.custom-header__search-mobile');
const body = document.body;

showButton.addEventListener('click', function(event){
  inputBar.classList.toggle('active');
  showButton.classList.toggle('active')
  body.classList.toggle('show-search');
})


//Mega menu open/hide logic

document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('.custom-header__menu-link');
  const megaMenus = document.querySelectorAll('.custom-header__mega-menu-wrapper');

  let activeMenu = null;

  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const index = link.dataset.linkIndex;

      megaMenus.forEach(menu => menu.classList.remove('show'));

      const targetMenu = document.querySelector(`.custom-header__mega-menu-wrapper[data-menu-index="${index}"]`);
      if (targetMenu) {
        targetMenu.classList.add('show');
        activeMenu = targetMenu;
      }
    });

    link.addEventListener('mouseleave', () => {
      if (!activeMenu) return;

      setTimeout(() => {
        if (!activeMenu.matches(':hover') && !Array.from(menuLinks).some(link => link.matches(':hover'))) {
          activeMenu.classList.remove('show');
          activeMenu = null;
        }
      }, 100); 
    });
  });

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      if (menu !== activeMenu) {
        activeMenu = menu;
        menu.classList.add('show');
      }
    });

    menu.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!menu.matches(':hover') && !Array.from(menuLinks).some(link => link.matches(':hover'))) {
          menu.classList.remove('show');
          activeMenu = null;
        }
      }, 100);
    });
  });
});

//Mobile Menu Header

const mobileMenu = document.querySelector('.mobile-menu');
const closeButton = document.querySelector('.mobile-menu__close');
const iconMenu = document.querySelector('.custom-header__icon-menu');

iconMenu.addEventListener('click', function (e) {
  mobileMenu.classList.add('active');
  document.body.classList.add('body-lock');
});

closeButton.addEventListener('click', function (e) {
  mobileMenu.classList.remove('active');
  document.body.classList.remove('body-lock');
});

document.addEventListener('click', function (e) {
  if (
    !mobileMenu.contains(e.target) && 
    !iconMenu.contains(e.target) && 
    mobileMenu.classList.contains('active')
  ) {
    mobileMenu.classList.remove('active');
    document.body.classList.remove('body-lock');
  }
});

//Menu Links filtration

document.addEventListener("DOMContentLoaded", () => {
  const megaMenus = document.querySelectorAll(".custom-header__mega-menu");

  megaMenus.forEach((menu, index) => {
    const children = Array.from(menu.children);
    let currentRow = null;
    let linkCounter = 0;
    let rowCounter = 1;

    children.forEach((child) => {
      if (index === 1 && child.tagName === "H3") {
        if (currentRow) {
          menu.appendChild(currentRow);
        }
        currentRow = createNewRow(rowCounter++);
        currentRow.appendChild(child);
        linkCounter = 0;
      } else if (child.tagName === "A") {
        if (!currentRow) {
          currentRow = createNewRow(rowCounter++);
          if (index === 1) {
            const emptyH3 = createEmptyH3();
            currentRow.appendChild(emptyH3);
          }
        }
        currentRow.appendChild(child);
        linkCounter++;
        const maxLinks = index === 1 ? 7 : 8;
        if (linkCounter === maxLinks) {
          menu.appendChild(currentRow);
          currentRow = null;
          linkCounter = 0;
        }
      }
    });

    if (currentRow) {
      menu.appendChild(currentRow);
    }
  });

  function createNewRow(rowNumber) {
    const row = document.createElement("div");
    row.className = `custom-header__mega-menu-row row_${rowNumber}`;
    return row;
  }

  function createEmptyH3() {
    const h3 = document.createElement("h3");
    h3.className = "empty title";
    return h3;
  }
});